import { BACKEND_ENDPOINTS, LEGAL_CHAT_ENDPOINTS } from "../services/apiEndpoints";
import { createChatSessionApi } from "../services/api/legalChatApi";
import { apiClient } from "../services/apiClient";

export const getChatHistory = (userId, chatId, page = 1, limit = 20) => async (dispatch) => {
  try {
    dispatch({
      type: "CHAT_HISTORY_REQUEST",
    });

    const endpoint = `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.GET_CHAT_HISTORY}`;
    const data = { user_id: userId, chat_id: chatId, page, limit };
    const response = await apiClient.post(endpoint, data);

    if (response.status === 200) {
      const responseData = response.data;
      dispatch({
        type: "CHAT_HISTORY_SUCCESS",
        payload: responseData,
      });
    } else {
      console.log("Chat history not found");
    }
  } catch (error) {
    dispatch({
      type: "CHAT_HISTORY_FAIL",
      payload: error.response?.data?.message ?? error.message,
    });
  }
};

export const editChatTitle = (userId, chatId, newTitle) => async (dispatch) => {
  try {
    const endpoint = `${BACKEND_ENDPOINTS.BASE_URL}${LEGAL_CHAT_ENDPOINTS.UPDATE_CHAT_SESSION}`;
    const response = await apiClient.put(endpoint, {
      chat_id: chatId,
      user_id: userId,
      chat_title: newTitle,
    });
    if (response.status === 200) {
      const responseData = response.data;
      console.log(responseData);
      dispatch({
        type: "EDIT_CHAT_TITLE",
        payload: { chatId, newTitle },
      });
      return responseData;
    } else {
      console.log("Title not found");
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message ?? error.message;
    console.log(errorMessage);
    throw new Error(errorMessage);
  }
};

export const deleteChat = (userId, chatId) => async (dispatch) => {
  try {
    const endpoint = `${BACKEND_ENDPOINTS.BASE_URL}${LEGAL_CHAT_ENDPOINTS.DELETE_CHAT_SESSION}`;
    const response = await apiClient.delete(endpoint, { chat_id: chatId, user_id: userId });
    if (response.status === 200) {
      dispatch({
        type: "DELETE_CHAT_TITLE",
        payload: { chatId },
      });
      console.log("Chat deleted");
    } else {
      console.log("Chat not found");
    }
  } catch (error) {
    if (error.response?.data?.message.toLowerCase() === "chat session not found.") {
      dispatch({
        type: "DELETE_CHAT_TITLE",
        payload: { chatId },
      });
    }
    console.log(error.response?.data?.message ?? error.message);
  }
};

export const getChatTitles = (userId) => async (dispatch) => {
  try {
    dispatch({
      type: "GET_CHAT_TITLES_REQUEST",
    });
    const endpoint = `${BACKEND_ENDPOINTS.BASE_URL}${LEGAL_CHAT_ENDPOINTS.GET_CHAT_SESSIONS}?user_id=${userId}`;

    const response = await apiClient.get(endpoint);
    if (response.status === 200) {
      const sessions = response.data;
      // Normalize _id → chat_id for reducer compatibility
      const normalizedSessions = Array.isArray(sessions)
        ? sessions.map((s) => ({ ...s, chat_id: s.chat_id ?? s._id }))
        : [];
      dispatch({
        type: "GET_CHAT_TITLES_SUCCESS",
        payload: normalizedSessions,
      });
    }
  } catch (error) {
    dispatch({
      type: "GET_CHAT_TITLES_FAIL",
      payload: "Failed to fetch chat titles.",
    });
  }
};

export const createChatSession = (userId, chatId, mode, query, title) => async (dispatch) => {
  try {
    const createdSession = await createChatSessionApi(userId, chatId, mode, query, title);

    const createdSessions = Array.isArray(createdSession)
      ? createdSession
      : createdSession
        ? [createdSession]
        : [];

    if (createdSessions.length > 0) {
      const normalizedSessions = createdSessions.map((session) => ({
        ...session,
        chat_id: session.chat_id ?? session._id,
      }));

      dispatch({
        type: "GET_CHAT_TITLES_SUCCESS",
        payload: normalizedSessions,
      });
      return normalizedSessions[0];
    }

    await dispatch(getChatTitles(userId));
    return null;
  } catch (error) {
    console.error("Failed to create chat session:", error.response?.data?.message ?? error.message);
    return null;
  }
};

export const togglePinChat = (userId, chatId, isPinned) => async (dispatch) => {
  try {
    const endpoint = `${BACKEND_ENDPOINTS.BASE_URL}${LEGAL_CHAT_ENDPOINTS.UPDATE_CHAT_SESSION}`;

    const response = await apiClient.put(endpoint, {
      chat_id: chatId,
      user_id: userId,
      is_pinned: !isPinned,
    });
    if (response.status === 200) {
      dispatch({
        type: "TOGGLE_PIN_CHAT",
        payload: { chatId, isPinned: !isPinned },
      });
    }
  } catch (error) {
    dispatch({
      type: "GET_CHAT_TITLES_FAIL",
      payload: "Failed to update pin status",
    });
  }
};
